/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * PageLoader - A branded loading spinner component for lazy-loaded pages
 * Uses LoadingSplash component for a consistent loading experience
 */

import React from "react";
import LoadingSplash from "./LoadingSplash";

const PageLoader: React.FC = () => <LoadingSplash />;

export default PageLoader;
